import { jsxs as ge, jsx as m, Fragment as We } from "react/jsx-runtime";
import { DotsIcon as ze } from "@systemeio/ui/icons";
import { Popover as Ke } from "@systemeio/ui";
import ye, { useRef as k, useState as Me, useTransition as Ne, useMemo as v, useEffect as Ae, Fragment as we } from "react";
import { useParagraphSpaceExtensionToolbar as Pe } from "../extensions/paragraph-extension/use-paragraph-space-extension.mjs";
import { twMerge as ke, twJoin as Ue } from "tailwind-merge";
import { EditorExtensionEnum as o } from "../enums/editor-extensions-enum.mjs";
import { ListEnum as ve } from "../extensions/list-extension/list-enum.mjs";
import { TextFormatEnum as p } from "../extensions/text-format-extension/text-format-enum.mjs";
import { useFontFamilyExtensionToolbar as Ve } from "../extensions/font-family-extension/use-font-family-extension-toolbar.mjs";
import { useFontSizeExtensionToolbar as je } from "../extensions/font-size-extension/use-font-size-extension-toolbar.mjs";
import { useHeadingExtensionToolbar as _e } from "../extensions/heading-extension/use-heading-extension-toolbar.mjs";
import { useHistoryExtensionToolbar as $e } from "../extensions/history-extension/use-history-extension-toolbar.mjs";
import { useImageExtensionToolbar as qe } from "../extensions/image-extension/use-image-extension-toolbar.mjs";
import { useIndentExtensionToolbar as De } from "../extensions/indent-extension/use-indent-extension-toolbar.mjs";
import { useLinkExtensionToolbar as Je } from "../extensions/link-extension/use-link-extension-toolbar.mjs";
import { useListExtensionToolbar as Fe } from "../extensions/list-extension/use-list-extension-toolbar.mjs";
import { useSpecialCharactersExtensionToolbar as Ge } from "../extensions/special-characters-extension/use-special-characters-extension-toolbar.mjs";
import { useSubstitutesExtensionToolbar as Qe } from "../extensions/substitutes-extension/use-substitutes-extension-toolbar.mjs";
import { useTextAlignExtensionToolbar as Xe } from "../extensions/text-align-extension/use-text-align-extension-toolbar.mjs";
import { useTextBackgroundColorExtensionToolbar as Ye } from "../extensions/text-background-color-extension/use-text-background-color-extension-toolbar.mjs";
import { useTextColorExtensionToolbar as Ze } from "../extensions/text-color-extension/use-text-color-extension-toolbar.mjs";
import { useTextFormatExtensionToolbar as x } from "../extensions/text-format-extension/use-text-format-extension-toolbar.mjs";
import { getExistingExtensions as Oe } from "../utils/get-extensions.mjs";
import { renderInSemanticOrder as F } from "./render-semantic-order.mjs";
import { semanticOrder as Se } from "./toolbar-semantic-order.mjs";
import { useLineHeightExtensionToolbar as eo } from "../extensions/line-height-extension/use-line-height-extension-toolbar.mjs";
const Bo = ({
  substitutions: Le,
  extensions: Ce,
  editor: r,
  toolbarStyles: Ie,
  fileSource: S,
  toolbarClassName: Be,
  showAllItems: b = !1,
  extensionOption: s
}) => {
  const {
    hasHistory: L,
    hasHeading: C,
    hasIndent: I,
    hasTextAlign: B,
    hasLink: R,
    hasTextColor: H,
    hasFontSize: W,
    hasTextBackgroundColor: z,
    hasFontFamily: K,
    hasSubstitution: M,
    hasSpecialCharacters: N,
    hasImage: A,
    hasOrderedList: w,
    hasBulletList: P,
    hasListItem: E,
    hasBold: U,
    hasItalic: V,
    hasUnderline: j,
    hasStrike: _,
    hasParagraph: $,
    hasSimpleHardBreak: q,
    hasLineHeight: D
  } = Oe(Ce), u = k(null), J = k(null), [h, G] = Me([]), [, Q] = Ne(), T = k([]), X = qe(r, S), Y = $e(r), Z = De(r), O = Je(r, S), ee = Xe(r), oe = _e(r), re = Qe(r, Le), te = x(r, p.Bold), se = x(r, p.Italic), ne = x(r, p.Underline), ie = x(r, p.Strike), ae = je(
    r,
    s == null ? void 0 : s[o.FontSize]
  ), le = Fe(r, ve.OrderedList), ce = Fe(r, ve.BulletList), fe = Ve(
    r,
    s == null ? void 0 : s[o.FontFamily]
  ), me = Ze(
    r,
    s == null ? void 0 : s[o.TextColor]
  ), ue = Ye(
    r,
    s == null ? void 0 : s[o.TextBackgroundColor]
  ), de = Ge(r), be = Pe(r), he = eo(r), n = v(() => {
    const t = [], e = (i, c) => {
      Array.isArray(i) ? i.forEach((a) => {
        t.push({
          toolbarItem: a,
          ref: ye.createRef(),
          key: c
        });
      }) : t.push({
        toolbarItem: i,
        ref: ye.createRef(),
        key: c
      });
    };
    return $ && !q && e(be, o.Paragraph), D && e(he, o.LineHeight), L && e(Y, o.History), A && e(X, o.Image), R && e(O, o.Link), I && e(Z, o.Indent), B && e(ee, o.TextAlign), C && e(oe, o.Heading), M && e(re, o.Substitution), U && e(te, o.Bold), V && e(se, o.Italic), j && e(ne, o.Underline), _ && e(ie, o.Strike), W && e(ae, o.FontSize), w && E && e(le, o.OrderedList), P && E && e(ce, o.BulletList), K && e(fe, o.FontFamily), H && e(me, o.TextColor), z && e(ue, o.TextBackgroundColor), N && e(de, o.SpecialCharacters), t;
  }, [
    $,
    q,
    be,
    D,
    he,
    L,
    Y,
    A,
    X,
    R,
    O,
    I,
    Z,
    B,
    ee,
    C,
    oe,
    M,
    re,
    U,
    te,
    V,
    se,
    j,
    ne,
    _,
    ie,
    W,
    ae,
    w,
    E,
    le,
    P,
    ce,
    K,
    fe,
    H,
    me,
    z,
    ue,
    N,
    de
  ]), Te = (t, e) => t.length === e.length && t.every((i, c) => i === e[c]);
  Ae(() => {
    const t = () => {
      var xe;
      if (!u.current) return;
      if (b) {
        const l = n.map((f) => f.key);
        Te(T.current, l) || (T.current = l, Q(() => G(l)));
        return;
      }
      const i = u.current.clientWidth, c = [...n].sort(
        (l, f) => Se.flatMap((d) => d).indexOf(l.key) - Se.flatMap((d) => d).indexOf(f.key)
      ), a = [];
      let g = 0, y = !1;
      const He = ((xe = J.current) == null ? void 0 : xe.offsetWidth) ?? 0;
      for (const l of c) {
        const f = l.ref.current;
        if (!f) continue;
        const d = f.offsetWidth, Ee = g + d;
        !y && Ee <= i ? (a.push(l.key), g = Ee) : y = !0;
      }
      y && a.length > 0 && g + He > i && a.pop(), Te(T.current, a) || (T.current = a, Q(() => G(a)));
    }, e = new ResizeObserver(t);
    return u.current && e.observe(u.current), t(), () => {
      e.disconnect();
    };
  }, [n, b]);
  const Re = v(
    () => n.filter((t) => h.includes(t.key)),
    [n, h]
  ), pe = v(
    () => n.filter((t) => !h.includes(t.key)),
    [n, h]
  );
  return /* @__PURE__ */ ge(
    "div",
    {
      style: Ie,
      className: ke(
        "border-text-secondary/30 z-sticky bg-background-secondary sticky top-0 flex items-center rounded-t-lg border border-b-0 p-1",
        Be
      ),
      children: [
        /* @__PURE__ */ ge(
          "div",
          {
            ref: u,
            className: ke("flex w-full", b && "flex-wrap gap-1"),
            children: [
              F({ source: Re, skipRef: !0 }),
              /* @__PURE__ */ m(
                "div",
                {
                  ref: J,
                  className: Ue(
                    "ml-auto flex items-center",
                    pe.length > 0 ? "visible" : "invisible",
                    b && "hidden"
                  ),
                  children: /* @__PURE__ */ m(
                    Ke,
                    {
                      anchor: "bottom end",
                      className: "main-transition-colors data-[open]:bg-brand-primary/10 group h-7 rounded-lg px-2",
                      label: /* @__PURE__ */ m(We, { children: F({
                        source: pe,
                        skipRef: !0,
                        skipBorder: !0,
                        inTooltip: !0
                      }) }),
                      children: /* @__PURE__ */ m(ze, { className: "group-hover:fill-brand-primary main-transition-colors" })
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ m("div", { className: "pointer-events-none absolute left-0 top-0 flex h-0 overflow-hidden opacity-0", children: F({ source: n }) }),
        n.filter(({ toolbarItem: t }) => t.additionalRender).map(({ toolbarItem: t, key: e }) => /* @__PURE__ */ m(we, { children: t.additionalRender }, `${e}-additional-render`))
      ]
    }
  );
};
export {
  Bo as Toolbar
};
